var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAppleMaps = function SvgAppleMaps(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M407,512H105C47.103,512,0,464.897,0,407V105C0,47.103,47.103,0,105,0h302 c57.897,0,105,47.103,105,105v302C512,464.897,464.897,512,407,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M407,0H256v512h151c57.897,0,105-47.103,105-105V105C512,47.103,464.897,0,407,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87E694"
    },
    d: "M407,0H130v148l356.429,327.6C502.354,457.186,512,433.199,512,407V105C512,47.103,464.897,0,407,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66CC70"
    },
    d: "M407,0H256v263.809L486.429,475.6C502.354,457.186,512,433.199,512,407V105 C512,47.103,464.897,0,407,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C0C0"
    },
    d: "M0,105v302c0,57.897,47.103,105,105,105h30V57H11.631C4.201,71.395,0,87.715,0,105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC40"
    },
    d: "M69.738,6.098c-29.577,10.577-53.063,34.063-63.64,63.64l436.164,436.164 c29.576-10.577,53.062-34.063,63.64-63.64L69.738,6.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAB15"
    },
    d: "M256,192.361V319.64l186.262,186.262c29.576-10.577,53.062-34.063,63.64-63.64L256,192.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M347,472c-68.925,0-125-56.075-125-125c0-25.508,7.648-50.058,22.118-70.998l12.504-18.096 l21.729,3.417C281.2,261.773,284.11,262,287,262c13.551,0,26.569-4.973,36.656-14.002L347,227.101l23.344,20.896 C380.431,257.027,393.449,262,407,262c2.89,0,5.8-0.227,8.649-0.675l21.729-3.418l12.504,18.096 C464.352,296.942,472,321.492,472,347C472,415.925,415.925,472,347,472z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M449.883,276.002l-12.504-18.096l-21.729,3.418C412.8,261.773,409.89,262,407,262 c-13.551,0-26.569-4.973-36.656-14.002L347,227.101l-23.344,20.896C313.569,257.027,300.551,262,287,262 c-2.89,0-5.8-0.227-8.649-0.676l-21.729-3.417l-0.622,0.9v173.795C278.813,456.84,311.167,472,347,472c68.925,0,125-56.075,125-125 C472,321.492,464.352,296.942,449.883,276.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M351,0c0,88.918,72.082,161,161,161v75C381.661,236,276,130.339,276,0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M105,0c-5.093,0-10.099,0.372-15,1.076v509.848c4.901,0.704,9.907,1.076,15,1.076h75V0H105z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    style: {
      fill: "#00AAF0"
    },
    width: 30,
    height: 246
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3FF"
    },
    d: "M135,391c-41.355,0-75-33.645-75-75s33.645-75,75-75s75,33.645,75,75S176.355,391,135,391z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "105,346 135,275 165,346 135,336 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3FF"
    },
    d: "M433.429,287.372l-5.359-7.755l-9.313,1.465C414.884,281.691,410.928,282,407,282 c-18.48,0-36.235-6.783-49.996-19.101L347,253.944l-10.004,8.956C323.235,275.217,305.48,282,287,282 c-3.928,0-7.884-0.309-11.757-0.918l-9.313-1.465l-5.359,7.755C248.422,304.954,242,325.573,242,347c0,57.897,47.103,105,105,105 s105-47.103,105-105C452,325.573,445.578,304.954,433.429,287.372z M347,422c-41.355,0-75-33.645-75-75c0-4.739,0.443-9.42,1.307-14 h147.387c0.864,4.58,1.307,9.261,1.307,14C422,388.355,388.355,422,347,422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M433.429,287.372l-5.359-7.755l-9.313,1.465C414.884,281.691,410.928,282,407,282 c-18.48,0-36.235-6.783-49.996-19.101L347,253.944l-10.004,8.956C323.235,275.217,305.48,282,287,282 c-3.928,0-7.884-0.309-11.757-0.918l-9.313-1.465l-5.359,7.755c-1.63,2.359-3.149,4.777-4.571,7.241v104.726 C274.159,430.789,308.148,452,347,452c57.897,0,105-47.103,105-105C452,325.573,445.578,304.954,433.429,287.372z M347,422 c-41.355,0-75-33.645-75-75c0-4.739,0.443-9.42,1.307-14h147.387c0.864,4.58,1.307,9.261,1.307,14C422,388.355,388.355,422,347,422z "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppleMaps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apple-maps.f65fd9b8.svg";
export { ForwardRef as ReactComponent };